module.exports = __webpack_public_path__ + "media/flags/pa-4dd0dc1a.svg";